module.exports = __webpack_public_path__ + "static/media/filesActive.c4962d0a.svg";